import React, { Fragment } from "react";
import css from "../../Assets/Styles/Home/testimonials.module.css";

import "../../Assets/Styles/Home/TestimonialsCard.css";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Navigation } from "swiper";
const TestimonialsCard = () => {
  return (
    <Fragment>
      {/* */}

      <Swiper
        rewind={true}
        navigation={true}
        modules={[Navigation]}
        className="testimonialsCard"
      >
        <SwiperSlide>
          {" "}
          <div>
            <h2 className=" text-[24px] max-sm:text-[42px] font-fira text-center rounded-xl text-[#0D1C37]  font-bold leading-[53px] mb-8">
              OUR LOVELY CUSTOMER
            </h2>
            <div
              className={`${css.testimonialsCard} w-[100%]  max-sm:w-[642px] text-center p-10 max-sm:px-[53px] max-sm:py-[43px]`}
            >
              <p className="text-[#0D1C37] text-[16px] max-sm:text-xl font-semibold leading-[37px] mb-[21px]">
                মাদানি অর্গানিক শপে, আমরা তাজা, স্বাস্থ্যকর পণ্য এবং চমৎকার
                গ্রাহক পরিষেবাকে অগ্রাধিকার দিই। আমরা IT Ghar পরিষেবাগুলির সাথে
                অংশীদারিত্ব করতে পেরে গর্বিত, যার ডিজিটাল সমাধানগুলি আমাদের আরও
                পরিবেশ-সচেতন ক্রেতাদের সাথে সংযোগ স্থাপন করতে এবং আমাদের
                কার্যক্রমকে সুবিন্যস্ত করতে সাহায্য করেছে।
              </p>
              <h3 className="font-fira text-2xl font-bold text-primary mb-1">
                মাদানী অর্গানিক শপ
              </h3>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <div>
            <h2 className=" text-[24px] max-sm:text-[42px] font-fira text-center rounded-xl text-[#0D1C37]  font-bold leading-[53px] mb-8">
              OUR LOVELY CUSTOMER
            </h2>
            <div
              className={`${css.testimonialsCard} w-[100%]  max-sm:w-[642px] text-center p-10 max-sm:px-[53px] max-sm:py-[43px]`}
            >
              <p className="text-[#0D1C37] text-[16px] max-sm:text-xl font-semibold leading-[37px] mb-[21px]">
                At Rifatenterprise, your satisfaction is our top priority. We
                offer gadget with a smile, and thanks to IT Ghar Services'
                efficient online systems, ordering and communication have never
                been easier. Experience the Rifatenterprise difference -
                personalized service, seamless experience, and lasting value!
              </p>
              <h3 className="font-fira text-2xl font-bold text-primary mb-1">
                Rifat Enterprise
              </h3>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </Fragment>
  );
};

export default TestimonialsCard;
